import React, { useContext, useEffect, useState } from 'react'
import Modal from '../../../../common/modal/Modal'
import { copyToClipboard, modalInviteLinkId } from './Utils'
import Button from '../../../../common/button/Button'
import { TeamContext } from '../../MenuTabs/MenuTabs'
import { useParams } from 'react-router-dom'
import ResponseMessage from '../../../../common/modal/ResponseMessage'
import { formRequest } from '../form/Utils'
import Icons from '../../../../common/icons/Icons'

const ModalInviteLink = ({}) => {

  const params = useParams()
  const teamId = params.team_id ?? 0
  const { teamData } = useContext(TeamContext)
  const [ responseMessage, setResponseMessage ] = useState('')
  const [ inviteLink, setInviteLink ] = useState('')
  const [ response, setResponse ] = useState(null)
  const [ isCopied, setIsCopied ] = useState(false)

  useEffect(() => {
    setInviteLink(teamData.team_invite_link)
  }, [])
  
  const formData = new FormData()
  formData.append('action', 'msync_regenerate_team_invite_link')
  formData.append('team_id', teamId)
  formData.append('nonce', group_dashboard.nonce_members)

  const { isLoading, isFetching, isError, error, refetch, data } = formRequest( formData, setResponseMessage )

  useEffect(() => {
    if( isError ){
      setResponse({ type: 'error', message: error.message })
    }else if( responseMessage ){
      setResponse({ type: 'error', message: responseMessage })
    }else if( data ){
      setInviteLink(data)
      setResponse({ type: 'success', message: `${teamData.team_name} invitation link was regenerated` })
    }
  }, [ isError, responseMessage, data, teamData ])

  useEffect(() => {
    if (response) {
      const timer = setTimeout(() => {
        setResponse(null)
        setResponseMessage('')
      }, 5000)
      return () => clearTimeout(timer)
    }
  }, [response])

  const handleCopyInviteLink = () => {
    if( isCopied ) return false
    const response = copyToClipboard( inviteLink )
    if( response ){
      setIsCopied(true)
      setTimeout(() => {
        setIsCopied(false)
      }, 1000);
    }
  }

  return (
    <Modal 
      modalId={ modalInviteLinkId } 
      modalHeading={ 'Invite Link' }
      buttonTitle={''}
      modalClassNames={'msync-members-custom-modal msync-members-custom-modal-border'}
      >
      <main className="msync-modal__body">
        { 
          response && 
          <ResponseMessage response={{
            type: response.type,
            message: response.message
          }} />
        }
        <div className='msync-member-invite-link'>
        {
          teamData.team_remaining_seats > 0 || teamData.team_seat_count === null
          ? <>
            <span>Members can register themselves for your team by clicking this registration link. Sharing this should be done with caution, as it gives any visitor the option to join your team.</span>
            <div className='msync-member-invite-link-form'>
              <div className='msync-member-invite-link-form-input'>
                <div className='msync-input-btn-group'>
                  <input
                    value={ inviteLink }
                    type="text" 
                    name='invite-link' 
                    placeholder='Invite link'
                    readOnly              
                  />
                  <Button
                    className='msync-button--is-theme-secondary'
                    onClick={ () => handleCopyInviteLink() }
                  >
                    {
                      isCopied 
                      ? <div className='msync-align-items-center'>
                          <Icons type='check' />
                          <span>Copied to clipboard</span>
                        </div> 
                      : 'Copy'
                    }
                  </Button>
                </div>
              </div>
              <div>
                <Button
                  className='msync-button--is-theme-secondary'
                  onClick={ () => refetch() }
                  name={ isLoading || isFetching ? 'Loading...' : 'Regenerate Link' }
                  disabled={ isLoading || isFetching ? true : false }
                />
              </div>
            </div>
            </>
          : <span> There are no more seats available for new members to join your team. </span>
        }
        </div>
      </main>
    </Modal>
  )
}

export default ModalInviteLink
